import { motion } from 'framer-motion'

function PageWrapper({ children, forceReadableWidth }) {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={{
        initial: {
          opacity: 0,
        },
        in: {
          opacity: 1,
        },
        out: {
          opacity: 0,
        },
      }}
      transition={{ type: 'tween', ease: 'anticipate', duration: 0.4 }}
      style={{
        maxWidth: forceReadableWidth ? '65ch' : undefined,
        minWidth: 0,
        paddingBottom: '2rem',
      }}
    >
      {children}
    </motion.div>
  )
}

export default PageWrapper
